import Dataman from 'App/Dataman';
import { PRODUCT_SUB_CATEGORIES_FOR_TABLE } from '@/app/utils/Collections';

export function NewsDomainsLoader() {
  return Dataman.DB.newsDomains.getList({ 'order[name]': 'asc' }).then((res) => {
    return res.data['hydra:member'].map((el) => ({ text: el.name, value: el.id }));
  });
}

export function searchNewsDomains(term) {
  const filter = { name: term, 'order[name]': 'asc' };
  return Dataman.DB.newsDomains.getList(filter).then((res) => {
    return res.data['hydra:member'].map((el) => ({ text: el.name, value: el.id }));
  });
}

export function searchAINewsDomains(term) {
  const filter = { name: term };
  return Dataman.DB.aiNewsDomains.getList(filter).then((res) => {
    return res.data.map((el) => ({ text: el.name, value: el.id }));
  });
}

export function tagsLoader() {
  return Dataman.DB.newsTags.getList({ 'order[name]': 'asc' }).then((res) => {
    return res.data['hydra:member'].map((el) => ({ text: el.name, value: el.id }));
  });
}

export function searchNewsTags() {
  const filter = { 'order[name]': 'asc' };
  return Dataman.DB.newsTags.getList(filter).then((res) => {
    return res.data['hydra:member'].map((el) => ({ name: el.name, id: el.id }));
  });
}

export function searchAINewsTags() {
  const filter = {};
  return Dataman.DB.aiNewsTags.getList(filter).then((res) => {
    return res.data?.map((el) => ({
      name: el.name,
      id: el.id,
      cat: PRODUCT_SUB_CATEGORIES_FOR_TABLE[el.category_id]?.abbr,
    }));
  });
}

export async function loadAINewPrompts(filter = {}) {
  return Dataman.DB.aiNewsPrompts.getList(filter).then((res) => {
    return res.data.items
      .map((el) => ({ text: el.prompt, name: el.name, value: el.id }))
      .sort((a, b) => (a.name || a.text).localeCompare(b.name || b.text));
  });
}

export async function loadThemes(term = '', modules = [], filters = {}) {
  return Dataman.Filter.getProductTypes({
    'translations.name': term,
    itemsPerPage: 200,
    modules,
    'order[translations.name]': 'asc',
    properties: ['id', 'name'],
    ...(filters || {}),
  }).then((res) => {
    return res?.data?.map((el) => ({ text: el.name, value: el.id }));
  });
}

export async function loadRegions(term = '', filters = {}) {
  return Dataman.Filter.getCountryRegions({
    name: term,
    itemsPerPage: 200,
    ...(filters || {}),
  }).then((res) => {
    return res?.data?.map((el) => ({ text: el.name, value: el.id }));
  });
}
